import ResourceTyped from 'Resources/ResourceTyped';

class Agent extends ResourceTyped<string> {
	constructor() {
		super('agent');
	}

	getOrCreateUserToken(): Promise<{ token: string; tokenExpires: number }> {
		return this._postRequest(`getOrCreateUserToken`).then(res => res.data);
	}

	runTrigger(data: { customerId: string | number; event: string; data: any }): Promise<any> {
		return this._postRequest('runTrigger', data).then(res => res.data);
	}
}

const resource = new Agent();

export default resource;
